module.exports = __webpack_public_path__ + "static/media/car-4.7fb2f62e.jpg";